import { useState } from 'react';
import { css } from '@emotion/react';
import { SMS } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { useMessageInsightsPanelShallowStore } from '../hooks/use-message-insights-panel-store';
import { PanelProps } from '../types';
import { MessageInsightsBubble } from './message-insights-bubble';
import { MessageInsightsHeader } from './message-insights-header';
import { MessageInsightsReasoning } from './message-insights-reasoning';

export const MessageInsightsContent = ({ panelStyles, onClose }: PanelProps) => {
  const { t } = useTranslation('message-insights-panel');
  const [smsTasks, setSmsTasks] = useState<SMS['tasks']>([]);

  const { selectedMessage: messageData } = useMessageInsightsPanelShallowStore('selectedMessage');

  if (!messageData) {
    return (
      <div css={[panelStyles, styles.wrapper]}>
        <MessageInsightsHeader onClose={onClose} />
        <div css={styles.emptyState}>
          <p>{t('No message selected')}</p>
        </div>
      </div>
    );
  }

  return (
    <div css={[panelStyles, styles.wrapper]}>
      <MessageInsightsHeader onClose={onClose} />
      <div css={styles.content}>
        <MessageInsightsBubble
          sourceId={messageData.messageId}
          locationId={messageData.locationId}
          onSmsLoaded={(sms) => setSmsTasks(sms?.tasks ?? [])}
        />
        <MessageInsightsReasoning
          subject={messageData?.escalationSubject}
          body={messageData?.escalationBody}
          outcomeBubble={messageData?.outcomeBubbleNode}
          tasks={smsTasks}
        />
      </div>
    </div>
  );
};

const styles = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden auto;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing(3)};
    gap: ${theme.spacing(2)};
    height: 100%;
    overflow: hidden auto;
  `,
  emptyState: css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    color: ${theme.colors.neutral50};
  `,
};
